import { render, staticRenderFns } from "./SkeletonFilterOPComponent.vue?vue&type=template&id=96ee6d24&scoped=true&"
import script from "./SkeletonFilterOPComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonFilterOPComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonFilterOPComponent.vue?vue&type=style&index=0&id=96ee6d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ee6d24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
